import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";
import { TRANSLATIONS_EN } from "./en";
import { TRANSLATIONS_DE } from "./de";
import { TRANSLATIONS_IT } from "./it";
import { TRANSLATIONS_FR } from "./fr";
import { getCookie } from "../utils/cookie";

export const languages = [
  { code: "en", name: "EN" },
  { code: "de", name: "DE" },
  { code: "it", name: "IT" },
  { code: "fr", name: "FR" }
];

let language = getCookie("i18nextLng");

i18n
  .use(initReactI18next)
  .use(XHR)
  .use(LanguageDetector)
  .init({
    lng: language
      ? language
      : "de",
    resources: {
      en: {
        translation: TRANSLATIONS_EN
      },
      de: {
        translation: TRANSLATIONS_DE
      },
      it: {
        translation: TRANSLATIONS_IT
      },
      fr: {
        translation: TRANSLATIONS_FR
      }
    },
    fallbackLng: "de",
    supportedLngs: ["de", "en", "it", "fr"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true
    },
  });
